import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import ProcessExtractResult from '@pages/candidate/userinput/ProcessExtractResult';
import {cloneDeep} from 'lodash';
import {requestCandidates} from "@app/services/CandidateService";
import {DEFAULT_PAGE_SIZE, LATEST_STABLE_LEVELS, MergeType, ResponseCode} from "@app/constants/Common";
import {requestCandidateGroups, requestSaveCandidateGroup} from "@app/services/CandidateGroupService";
import Select from "react-select";
import {InitSavedListInfo, SavedListLevels, SavedListTabOptions} from "@pages/savedlist/common/Constant";
import {validateSaveCandidateGroup} from "@pages/savedlist/common/ValidateUtils";
import {PROVINCE_OPTIONS} from "@app/constants/Provinces";
import {stringToArray} from "@app/utils/CommonUtils";
import {showMessage} from "@app/constants/Messages";

const MergeCandidateGroupModal = (props) => {
    const [group, setGroup] = useState(InitSavedListInfo);

    const [isLoading, setIsLoading] = useState(false)
    const [groupSelect, setGroupSelect] = useState({group1: '', group2: '', mergeType: MergeType.HOP})
    const [groupSelectOptions, setGroupSelectOptions] = useState([])

    const [candidateGroups, setCandidateGroups] = useState([]);

    const {isShow} = props
    const {groups} = props
    const {onClose} = props



    const getCandidateGroups = async () => {
        setIsLoading(true)
        let params = {search_conditions: {unlimited: true}}
        const res = await requestCandidateGroups(params);
        setIsLoading(false)
        let groupSelects = []
        if (res.content && res.content.saved_list) {
            res.content.saved_list.forEach(g => {
                groupSelects.push({value: g.id, label: g.name})
            })
            setGroupSelectOptions([...groupSelects])

            setCandidateGroups(res.content.saved_list)
        }

    }

    useEffect(() => {
        setGroup(InitSavedListInfo)
        getCandidateGroups();
    }, []);

    const onChangeGroupSelect = (event, fieldName) => {
        if (fieldName === 'group1' || fieldName === 'group2') {
            groupSelect[fieldName] = event
        } else {
            groupSelect[event.target.name] = event.target.value
        }

        setGroupSelect({...groupSelect})
    }

    const onSaveGroup = () => {
        if (!validateSaveCandidateGroup(group)) {
            return;
        }

        if (!groupSelect.group1 || !groupSelect.group2 || !groupSelect.mergeType) {
            alert("Vui lòng nhập đầy đủ thông tin các saved list và loại merge.")
            return
        }


        let groupObject1 = null
        let groupObject2 = null

        candidateGroups.forEach(g => {
            if (g.id === Number(groupSelect.group1.value)) {
                groupObject1 = {...g}
                groupObject1.candidate_ids = []
                if (g.candidate_ids) {
                    groupObject1.candidate_ids = stringToArray(g.candidate_ids)
                }
            }

            if (g.id === Number(groupSelect.group2.value)) {
                groupObject2 = {...g}
                groupObject2.candidate_ids = []
                if (g.candidate_ids) {
                    groupObject2.candidate_ids = stringToArray(g.candidate_ids)
                }
            }
        })

        if (groupObject1.id === groupObject2.id) {
            alert("Không thể chọn 2 saved list giống nhau.")
            return
        }

        group.candidate_ids = []
        // giao 2 list => lấy các phần từ thuộc cả 2 list.
        if (MergeType.GIAO === groupSelect.mergeType) {
            groupObject1.candidate_ids.forEach(gid => {
                if (groupObject2.candidate_ids.includes(gid.trim())) {
                    group.candidate_ids.push(gid.trim())
                }
            })
        }

        // Trường hợp tổng hợp từ 2 list => gộp 2 list thành 1 và remove các item trùng nhau
        if (MergeType.HOP === groupSelect.mergeType) {
            group.candidate_ids = groupObject1.candidate_ids
            groupObject2.candidate_ids.forEach(gid => {
                if (!group.candidate_ids.includes(gid.trim())) {
                    group.candidate_ids.push(gid.trim())
                }
            })
        }

        // Trường hợp list1 - list 2 => chỉ lấy các phần từ trong list1 mà không có trong list2
        if (MergeType.TRU === groupSelect.mergeType) {
            group.candidate_ids = []
            groupObject1.candidate_ids.forEach(gid => {
                if (!groupObject2.candidate_ids.includes(gid.trim())) {
                    group.candidate_ids.push(gid.trim())
                }
            })
        }

        if (group.candidate_ids.length === 0) {
            alert("Không thể tạo ra 1 saved list trống từ 2 saved list này.")
            return
        }

        const body = {...group}
        body.tab = group.tab.value

        setIsLoading(true)
        requestSaveCandidateGroup(body).then((res) => {
            if (res.sts_code === ResponseCode.SUCCESS) {
                onClose(true)
            } else if (res.sts_code === ResponseCode.EXISTS_SAVED_LIST) {
                showMessage("Tên saved list đã tồn tại trên phần mềm", false, true, true)
            } else {
                showMessage("Tạo saved list mới thất bại", false, true, true)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const setGroupItem = (event) => {
        group[event.target.name] = event.target.value
        setGroup({...group})
    }

    const setTabItem = (values) => {
        group.tab = values
        setGroup({...group})
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Tạo list từ list</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}>Saved list 1</label>
                            <div className={'w-100'}>
                                <Select options={groupSelectOptions}
                                        name={'group1'}
                                        value={groupSelect.group1}
                                        onChange={value => onChangeGroupSelect(value, 'group1')}>
                                    {/*<option value=''> </option>*/}
                                    {/*{groupSelectOptions.map(item => (*/}
                                    {/*    <option value={item.value} key={`group-select1-${item.value}`}>{item.label}</option>*/}
                                    {/*))}*/}
                                </Select>
                            </div>
                        </div>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}>Saved list 2</label>
                            <div className={'w-100'}>
                                <Select options={groupSelectOptions}
                                        name={'group2'}
                                        value={groupSelect.group2}
                                        onChange={value => onChangeGroupSelect(value, 'group2')}>
                                    {/*<option value=''> </option>*/}
                                    {/*{groupSelectOptions.map(item => (*/}
                                    {/*    <option value={item.value} key={`group-select1-${item.value}`}>{item.label}</option>*/}
                                    {/*))}*/}
                                </Select>
                            </div>
                        </div>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}>Loại merge</label>
                            <select className='form-control'
                                    name={'mergeType'}
                                    value={groupSelect.mergeType}
                                    onChange={event => onChangeGroupSelect(event, 'mergeType')}>
                                <option value='1'>Giao 2 saved list</option>
                                <option value='2'>Gộp 2 saved list</option>
                                <option value='3'>List1 - List2</option>
                            </select>
                        </div>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}>Tên saved list mới</label>
                            <input type='text' className='form-control' placeholder='Tên saved list mới'
                                   value={group.name}
                                   name={'name'} onChange={event => setGroupItem(event)}/>
                        </div>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}>Tên Tab</label>
                            <div style={{width: '100%'}}>
                                <Select options={SavedListTabOptions}
                                        value={group.tabs}
                                        name={'tab'}
                                        onChange={value => {
                                            setTabItem(value);
                                        }}
                                />
                            </div>
                        </div>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}>Level</label>
                            <select className={`form-control`}
                                    value={group.level}
                                    name={'level'}
                                    onChange={event => setGroupItem(event)}>
                                {SavedListLevels.map(item => (
                                    <option value={item}>{item}</option>
                                ))}
                            </select>
                        </div>
                        <div className='input-group mt-3'>
                            <label className={'w-100'}>Notes</label>
                            <input type='text' className='form-control' placeholder='Notes'
                                   value={group.notes}
                                   name={'notes'} onChange={event => setGroupItem(event)}/>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={
                                isLoading
                            }
                            onClick={() => {
                                onSaveGroup()
                            }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default MergeCandidateGroupModal;
